import CustomComponent from '../CustomComponent';

export class PromotionalHeroBannerComponent extends CustomComponent {
	static key = 'lta-promotional-hero-banner-component';

	static get observedAttributes() {
		return [
			'title',
			'subtitle',
			'play-store-button-link',
			'app-store-button-link',
			'default-button-link',
			'default-button-type',
			'feature-img-src',
			'classes'
		];
	}

	render() {
		const {
			title = '',
			subtitle = '',
			featureImgSrc = '',
			playStoreButtonLink = '',
			appStoreButtonLink = '',
			defaultButtonLink = '',
			defaultButtonType = '',
			classes = ''
		} = this.props;

		const renderButton = () => {
			let buttons = '';

			if (appStoreButtonLink) {
				buttons += `
                    <a class="lta-promotional-hero-banner__app-store-button-wrapper" href="${appStoreButtonLink}" target="_blank" rel="noopener">
                        <img
                            class="lta-promotional-hero-banner__app-button"
                            src="/static/images/app-store.svg"
                            alt="Download on the App Store"
                        />
                    </a>
		        `;
			}

			if (playStoreButtonLink) {
				buttons += `
                    <a class="lta-promotional-hero-banner__play-store-button wrapper" href="${playStoreButtonLink}" target="_blank" rel="noopener">
                        <img
                            class="lta-promotional-hero-banner__app-button"
                            src="/static/images/play-store.svg"
                            alt="Get it on Google Play"
                        />
                    </a>
                `;
			}

			if (defaultButtonLink) {
				buttons += `
			        <a href="${defaultButtonLink}" class="lta-btn lta-btn--lg lta-btn--${defaultButtonType}">Download the app</a>
		        `;
			}

			return buttons;
		};

		return `
			<div class="lta-promotional-hero-banner ${classes}">
				<div class="lta-promotional-hero-banner__page-wrapper">
					<div class="lta-promotional-hero-banner__wrapper">
						<div class="lta-promotional-hero-banner__content-wrapper">
							<div class="lta-promotional-hero-banner__content">
								<div class="lta-promotional-hero-banner__title u-herotitle2 u-text-white">${title}</div>
								<p class="lta-promotional-hero-banner__subtitle u-subtitle1 u-text-white">${subtitle}</p>
							</div>
							<div class="lta-promotional-hero-banner__app-buttons-container">
                                <div class="lta-promotional-hero-banner__app-buttons-wrapper">
                                    ${renderButton()}
                                </div>
							</div>
						</div>
						${
							featureImgSrc &&
							`
							<div class="lta-promotional-hero-banner__image-wrapper">
								<div class="lta-promotional-hero-banner__inner-image-wrapper">
									<img
										class="lta-promotional-hero-banner__image"
										src="${featureImgSrc}"
										alt="Phone Mockup"
									/>
								</div>
							</div>
						`
						}
					</div>
				</div>
			</div>
		`;
	}
}

export default PromotionalHeroBannerComponent;
